import { useMemo, type CSSProperties, type FC } from "react";
import { useRecoilState } from "recoil";

import { SelectOptionsDropdown } from "@ryde/controls";
import {
  selectedTableRowsIdsAtomFamily,
  useFormats,
  type IRidesCalendarEventDto,
  type SelectionEnum,
} from "@ryde/shared";

import {
  applySelectionToIds,
  computeSelectionState,
  formatRideCalendarHourLabel,
  getRideIdsForRow,
} from "../rides-calendar.helpers";
import { RIDES_CALENDAR_ENTITY } from "./rides-calendar.constants";

interface IHourLabelProps {
  style: CSSProperties;
  hourIndex: number;
  eventMap: Map<string, IRidesCalendarEventDto[]>;
}

export const RidesCalendarHourLabelCell: FC<IHourLabelProps> = ({
  style,
  hourIndex,
  eventMap,
}) => {
  const { timeFormat } = useFormats();
  const label = formatRideCalendarHourLabel(hourIndex, timeFormat);

  const [selectedIds, setSelectedIds] = useRecoilState(
    selectedTableRowsIdsAtomFamily(RIDES_CALENDAR_ENTITY),
  );

  const rowIds = useMemo(
    () => getRideIdsForRow(eventMap, hourIndex),
    [eventMap, hourIndex],
  );
  const selectionState = useMemo(
    () => computeSelectionState(rowIds, new Set(selectedIds)),
    [rowIds, selectedIds],
  );

  const handleSetChecked = (value: SelectionEnum): void => {
    setSelectedIds(prev =>
      applySelectionToIds({ ids: rowIds, selectedIds: prev, value }),
    );
  };

  return (
    <div className="rc-hour-cell" style={style}>
      <span className="rc-hour-cell__select">
        <SelectOptionsDropdown
          checked={selectionState}
          setChecked={handleSetChecked}
        />
      </span>
      <span className="rc-hour-cell__label">{label}</span>
    </div>
  );
};
